const PRODUCTION_INCENSE_API_BASE_URL = 'https://strata.saveonenergy.cloud/incense-api'
const STAGING_INCENSE_API_BASE_URL = 'https://strata.staging.saveonenergy.cloud/incense-api'

/**
 * Resolve the API base URL for the Incense backend.
 * Uses process.env in Node.js and test environments.
 * Browser consumers should pass `environment` (from build-time Vite env) via LoggerAdapterConfig.
 */
export function getIncenseApiBaseUrl(environment?: string | null): string {
  const explicitBaseUrl =
    typeof process !== 'undefined' &&
    process.env &&
    (process.env['VITE_INCENSE_BACKEND_URL'] || process.env['INCENSE_BACKEND_URL'])

  if (typeof explicitBaseUrl === 'string' && explicitBaseUrl.length > 0) {
    return explicitBaseUrl
  }

  const mode: string =
    (typeof environment === 'string' && environment.length > 0 ? environment : undefined) ||
    (typeof process !== 'undefined' && process.env && process.env['VITE_ENVIRONMENT']) ||
    'development'

  const isProd: boolean = mode === 'production'

  return isProd ? PRODUCTION_INCENSE_API_BASE_URL : STAGING_INCENSE_API_BASE_URL
}
